function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(248, 247, 241)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'solid-brass-round': 'url("//provenhands.com/cdn/shop/files/Proven-Hands-Full-Grain-Leather-Belt-Made-in-USA-buckles-solid-brass-heel-bar-v2_120x.jpg?v=1163720559861619168")','solid-brass-square': 'url("//provenhands.com/cdn/shop/files/Proven-Hands-Full-Grain-Leather-Belt-Made-in-USA-buckles-solid-brass-heel-bar-square-v2_120x.jpg?v=4336274801954434887")','nickel-square': 'url("//provenhands.com/cdn/shop/files/Proven-Hands-Full-Grain-Leather-Belt-Made-in-USA-buckles-nickel-heel-bar-v3_120x.jpg?v=4341227951005230436")','black-square': 'url("//provenhands.com/cdn/shop/files/Proven-Hands-Full-Grain-Leather-Belt-Made-in-USA-buckles-black-heel-bar-v2_120x.jpg?v=17259616216587557640")','nickel-roller': 'url("//provenhands.com/cdn/shop/files/Proven-Hands-Full-Grain-Leather-Belt-Made-in-USA-buckles-gun-metal-roller-v3_120x.jpg?v=4194375696951146111")',};

    this.triggers = ['color','colour','couleur','farbe','cor','buckle','pick your buckle','style',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
